import React, { useState } from 'react';
import CheckoutModal from './CheckoutModal';
import './PlanosModal.css';

function PlanosModal({ onClose }) {
    const [loading, setLoading] = useState(null);
    const [checkoutPlano, setCheckoutPlano] = useState(null);

    const handleSelect = async (plano) => {
        setLoading(plano);
        try {
            const token = localStorage.getItem('token');
            const resp = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/pagamentos/checkout-anuncio`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ plano })
            });
            const data = await resp.json();
            if (data.url) {
                window.location.href = data.url;
            } else {
                alert('Erro ao gerar pagamento. Tente novamente.');
            }
        } catch (e) {
            alert('Falha na comunicação com o gateway.');
        } finally {
            setLoading(null);
        }
    };

    if (checkoutPlano) {
        return (
            <CheckoutModal
                plano={checkoutPlano}
                onClose={onClose}
                onConfirmado={() => window.location.reload()}
            />
        );
    }

    return (
        <div className="planos-modal-overlay">
            <div className="planos-modal-content">
                <button className="planos-close-btn" onClick={onClose}>×</button>

                <div className="planos-header">
                    <span className="planos-header-badge">Agroov Pro</span>
                    <h2>Desbloqueie o Catálogo de Gado</h2>
                    <p>Publique com segurança e alcance compradores e motoristas verificados.</p>
                </div>

                <div className="planos-grid">
                    {/* AVULSO */}
                    <div className="plano-card">
                        <div className="plano-emoji">🐄</div>
                        <h3>Anúncio Avulso</h3>
                        <div className="plano-price">R$ 49,90<span> /único</span></div>
                        <ul className="plano-features">
                            <li>✓ 1 Publicação de Gado</li>
                            <li>✓ <strong>Validade de 30 dias</strong></li>
                            <li>✓ Exposição Imediata</li>
                            <li>✓ Match com Caminhoneiros</li>
                            <li>✓ Fotos e Vídeos ilimitados</li>
                        </ul>
                        <button
                            className="btn-plano btn-avulso"
                            disabled={loading !== null}
                            onClick={() => handleSelect('anuncio_avulso')}
                        >
                            {loading === 'anuncio_avulso' ? '⏳ Aguarde...' : 'Pagar com PIX'}
                        </button>
                    </div>

                    {/* PRO */}
                    <div className="plano-card premium">
                        <div className="plano-badge">⚡ Mais Popular</div>
                        <div className="plano-emoji">⭐</div>
                        <h3>Produtor PRO</h3>
                        <div className="plano-price">R$ 149,90<span> /mês</span></div>
                        <ul className="plano-features">
                            <li>✨ Anúncios Ilimitados</li>
                            <li>✨ <strong>Validade de 60 dias por anúncio</strong></li>
                            <li>✨ Selo Verificado Dourado</li>
                            <li>✨ Destaque no Catálogo</li>
                            <li>✨ Prioridade no Match de Fretes</li>
                            <li>✨ Suporte Prioritário</li>
                        </ul>
                        <button
                            className="btn-plano btn-premium"
                            disabled={loading !== null}
                            onClick={() => handleSelect('anuncios_ilimitados')}
                        >
                            {loading === 'anuncios_ilimitados' ? '⏳ Aguarde...' : 'Assinar PRO'}
                        </button>
                    </div>
                </div>

                <p className="planos-footer">🔒 Pagamento 100% seguro via PIX · Confirmação instantânea</p>
            </div>
        </div>
    );
}

export default PlanosModal;
